import { css } from 'styled-components';

export const globalFonts = css`
  // Widget
  @import url('https://fonts.googleapis.com/css?family=Ubuntu:400,500,700&display=swap');
  // New BE
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600;700&display=swap');
`;
